import { registerLocaleData } from '@angular/common';
import localeCH from '@angular/common/locales/de-CH';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
Sentry.init({
    dsn: "https://69f5eefedabc4486dcc085824727d0f3@o4510425149669376.ingest.de.sentry.io/4510425895927888",
    // Adds request headers and IP for users, for more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/angular/configuration/options/#sendDefaultPii
    sendDefaultPii: false,
    environment: environment.instance,

    // 2. Intercept and scrub data before it leaves the browser
    beforeSend(event) {
        if (event.request && event.request.url) {
            // Redact emails from URLs
            event.request.url = event.request.url.replace(
                /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g,
                "[EMAIL_REDACTED]"
            );
        }

        // 3. Scrub Breadcrumbs (console logs, etc.) attached to the event
        // Note: breadcrumbs are stored on the event in a slightly deep structure
        if (event.breadcrumbs) {
            event.breadcrumbs = event.breadcrumbs.map(breadcrumb => {

                if (breadcrumb.category === 'xhr' || breadcrumb.category === 'fetch') {
                    // Remove sensitive query params from API calls logged as breadcrumbs
                    // e.g. /api/user?token=123 -> /api/user
                    if (breadcrumb.data && breadcrumb.data["url"]) {
                        breadcrumb.data["url"] = breadcrumb.data["url"].split('?')[0];
                    }
                }
                return breadcrumb;
            });
        }

        // 4. Clean User Data
        // Ensure no specific user data is attached unless you explicitly want the ID
        if (event.user) {
            delete event.user.email;
            delete event.user.ip_address;
        }

        return event;
    },
});

registerLocaleData(localeCH);

if (environment.production) {
    enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
    platformBrowserDynamic()
        .bootstrapModule(AppModule)
        .catch((err) => console.error(err));
});